// extracted by mini-css-extract-plugin
export default {"root":"buttonStyles_root__WcfRE"};